import React, {memo} from "react";
import {Modal} from "react-bootstrap";
import BaseModal from "../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {actionDataMyOrders, handelCloseModalMyOrders} from "../../../../../redux/actions/modals/myOrders/modalMyOrders";
import CardMyOrder from "../../card/CardMyOrder";
import LoaderModals from "../../loaders/LoaderModals";
import InfiniteScroll from "react-infinite-scroll-component";
import axios from "axios";
import {BASE_URL, USERS_ORDERS_HISTORY_POST} from "../../../../../apis";
import qs from "querystring";
import CardMyOrderWithEdit from "../../card/CardMyOrderWithEdit";
import {FaTimesCircle} from "react-icons/all";

const ModalMyOrders = () => {
    const dispatch = useDispatch();
    const {statusShow, loader, contents, offset, total_rows} = useSelector(state => state.modalMyOrders);
    const {token} = useSelector(state => state.user);

    const handleClose = () => {
        dispatch(handelCloseModalMyOrders());
    };

    const apiGetListOrders = () => {
        axios({
            method: 'post',
            url: BASE_URL + USERS_ORDERS_HISTORY_POST,
            data: qs.stringify({offset}),
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': token
            },
        }).then((response) => {
            if (response.data.status === 'ok') {
                const {contents: contents_api, total_rows: total_rows_api} = response.data;
                dispatch(actionDataMyOrders(contents.concat(contents_api), total_rows_api, (offset + 15)));
            }
        });
    };

    return (
        <React.Fragment>
            <BaseModal title={'سفارشات من'}
                       show={statusShow}
                       dialogClassName={''}
                       handleClose={handleClose}>
                {!loader ? <Modal.Body id={'scrollableBodyModalMyOrders'}>
                        <div>
                            <InfiniteScroll
                                dataLength={offset}
                                next={apiGetListOrders}
                                hasMore={contents.length < total_rows}
                                loader={<h5 className={'text-center text-success mt-1'}>درحال بارگزاری ...</h5>}
                                scrollableTarget="scrollableBodyModalMyOrders"
                            >
                                {contents.length > 0 ?
                                    <React.Fragment>
                                        {contents.map((item, key) => <div className={'p-2'} key={key}>
                                            {item.can_edit
                                                ? <CardMyOrderWithEdit data={{item}}/>
                                                : <CardMyOrder data={{item}}/>}
                                        </div>)}
                                    </React.Fragment>
                                    :
                                    <div className={'box-not-find-transaction-modal-wallet'}>
                                        <div className={'not-find-transaction-modal-wallet'}>
                                            <FaTimesCircle className={'icon-not-find-transaction-modal-wallet'}/>
                                            <p>تا کنون سفارشی ثبت نکرده اید</p>
                                        </div>
                                    </div>
                                }
                            </InfiniteScroll>
                        </div>
                    </Modal.Body>
                    : <LoaderModals/>}
            </BaseModal>
        </React.Fragment>
    );
};

export default memo(ModalMyOrders);
